import { render, staticRenderFns } from "./BottomContent.vue?vue&type=template&id=5f3c3a07&scoped=true"
import script from "./BottomContent.vue?vue&type=script&lang=js"
export * from "./BottomContent.vue?vue&type=script&lang=js"
import style0 from "./BottomContent.vue?vue&type=style&index=0&id=5f3c3a07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3c3a07",
  null
  
)

export default component.exports